module.exports = __webpack_public_path__ + "img/smile.985edeb5.svg";